import { useEffect, useState } from "react";
import { fmtDateTime } from "@/components/DatePicker";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { MapPin, Camera, AlertTriangle } from "lucide-react";

function Loc({ loc }) {
  if (!loc) return <span className="text-muted-foreground">—</span>;
  if (loc.unavailable) return <span className="text-amber-600 flex items-center gap-1"><AlertTriangle className="w-3 h-3" /> No GPS</span>;
  if (loc.on_site === true) return <span className="text-emerald-600 flex items-center gap-1"><MapPin className="w-3 h-3" /> On-site · {loc.distance_m}m</span>;
  if (loc.on_site === false) return <span className="text-rose-600 flex items-center gap-1 font-medium"><AlertTriangle className="w-3 h-3" /> Off-site · {loc.distance_m}m</span>;
  return <span className="text-muted-foreground flex items-center gap-1"><MapPin className="w-3 h-3" /> Logged</span>;
}

function Photo({ src, testid }) {
  if (!src) return <span className="w-9 h-9 rounded-md bg-muted grid place-items-center text-muted-foreground"><Camera className="w-3.5 h-3.5" /></span>;
  return <a href={src} target="_blank" rel="noreferrer"><img data-testid={testid} src={src} alt="punch" className="w-9 h-9 rounded-md object-cover border border-border" /></a>;
}

const t = (iso) => (iso ? fmtDateTime(iso) : "—");

export function PunchLog({ companyId }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!companyId) return;
    api.get(`/companies/${companyId}/punches`, { params: { limit: 25 } }).then((r) => setRows(r.data)).catch(() => {});
  }, [companyId]);

  return (
    <Card className="p-5" data-testid="punch-log">
      <h3 className="font-semibold font-display mb-3">Recent Kiosk Punches</h3>
      {rows.length === 0 ? <p className="text-sm text-muted-foreground">No kiosk punches yet.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs text-muted-foreground text-left">
              <tr><th className="py-2 pr-3">Employee</th><th className="pr-3">In</th><th className="pr-3">Out</th><th className="pr-3">Hours</th><th className="pr-3">Location</th><th>Photos</th></tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} data-testid={`punch-row-${r.id}`} className="border-t border-border">
                  <td className="py-2 pr-3"><div className="font-medium">{r.employee_name}</div><div className="text-xs text-muted-foreground">{r.job_title}</div></td>
                  <td className="pr-3 font-mono-num whitespace-nowrap">{t(r.clock_in)}</td>
                  <td className="pr-3 font-mono-num whitespace-nowrap">{t(r.clock_out)}</td>
                  <td className="pr-3 font-mono-num">{r.status === "open" ? <span className="text-emerald-600">On clock</span> : r.hours?.toFixed(2)}</td>
                  <td className="pr-3 text-xs"><div><Loc loc={r.location_in} /></div>{r.clock_out && <div className="mt-0.5"><Loc loc={r.location_out} /></div>}</td>
                  <td><div className="flex gap-1"><Photo src={r.photo_in} testid={`photo-in-${r.id}`} /><Photo src={r.photo_out} testid={`photo-out-${r.id}`} /></div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
